exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body {\n  font-family: 'Lato', sans-serif;\n  margin: 0;\n  background-color: #fcfcfc; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path][name]-[local]!./~/postcss-loader!./~/sass-loader!./app/global.scss
// module id = 378
// module chunks = 0